import {
  containsNodeText,
  getSelectedHtml,
  replaceSelectedElement,
  replaceSelectionWithoutFormat,
  restoreSelectionFromNodeList,
  setCaretAfterElement,
  unwrapHTML,
  wrapAllChildrens,
} from "../../dom";
import { isCaretStartOrEnd } from "../../helpers/richtext/caret-position";
import $ from "jquery";
var linkSchema = {
  tagName: ["a"],
  matchQuery: "a",
  element: "a",
  applyFormat: function (formatProps, selection, editorDocument) {
    var selHTML;

    if (selection.toString() === "") {
      // If no Selection is selected
      selHTML = "&#8203;";
    } else {
      selHTML = getSelectedHtml(editorDocument);
    }

    // Remove existing formats from html
    selHTML = unwrapHTML(selHTML, this.matchQuery);

    var formatElement = document.createElement(this.element);

    formatElement.href = formatProps?.href ? formatProps.href : "";

    if (formatProps?.rel) {
      formatElement.setAttribute("rel", formatProps.rel);
    }

    if (formatProps?.target) {
      formatElement.setAttribute("target", formatProps.target);
    }

    formatElement.innerHTML = selHTML;

    return replaceSelectedElement(
      selection,
      editorDocument,
      formatElement,
      false,
    );
  },
  wrapFormat: function (element, formatProps) {
    var formatElement = document.createElement(this.element);

    formatElement.href = formatProps?.href ? formatProps.href : "";

    if (formatProps?.rel) {
      formatElement.setAttribute("rel", formatProps.rel);
    }

    if (formatProps?.target) {
      formatElement.setAttribute("target", formatProps.target);
    }

    wrapAllChildrens(formatElement, element);
  },
  unWrapFormat: function (element) {
    // Get all format elements
    var formatElements = element.querySelectorAll(this.matchQuery);

    // Sanitize the text by unwrapping format element
    for (var i = 0; i < formatElements.length; i++) {
      $(formatElements[i]).contents().unwrap();
    }
  },
  removeFormat: function (
    formatProps,
    selection,
    formatElement,
    editorDocument,
    restoreSelection,
  ) {
    let range = selection.getRangeAt(0);
    if (
      selection.toString() === "" ||
      containsNodeText(range, formatElement[0])
    ) {
      // If caret is at end then add a zero width character outside the format element and set the caret to it
      const { atStart, atEnd } = isCaretStartOrEnd(
        editorDocument,
        formatElement[0],
      );

      if (!atStart && atEnd) {
        setCaretAfterElement(editorDocument, formatElement[0], selection);

        return;
      }

      // Unwrap format element
      var unwrappedNodes = formatElement.contents().unwrap();

      // Restore Selection For Nodes
      restoreSelectionFromNodeList(editorDocument, selection, unwrappedNodes);

      return {
        firstChild: unwrappedNodes[0],
        lastChild: unwrappedNodes[unwrappedNodes.length - 1],
      };
    }

    return replaceSelectionWithoutFormat(
      editorDocument,
      selection,
      range,
      formatElement,
      this.element,
      restoreSelection,
    );
  },
  getFormatProps: function (formatElement, editorDocument) {
    if (!formatElement) {
      return;
    }

    return {
      href: formatElement.attr("href"),
      rel: formatElement.attr("rel"),
      target: formatElement.attr("target"),
      referrerpolicy: formatElement.attr("referrerpolicy"),
    };
  },
  updateFormat: function (formatProps, formatElement, editorDocument) {
    if (!formatElement) {
      return;
    }

    if (formatProps?.href) {
      formatElement.attr("href", formatProps.href);
    }

    if (formatProps?.rel) {
      formatElement.attr("rel", formatProps.rel);
    } else {
      formatElement.removeAttr("rel");
    }

    if (formatProps?.target) {
      formatElement.attr("target", formatProps.target);
    }

    if (formatProps?.referrerpolicy) {
      formatElement.attr("referrerpolicy", formatProps.referrerpolicy);
    }
  },
};

export { linkSchema };
